<template>
  <div id="result-layout">
    test
  </div>
</template>


<script>
export default {
  name: 'ResultLayout'
}
</script>

<style lang="scss" scoped>

</style>

